module.exports = __webpack_public_path__ + "static/media/siddharth-vidhana-soudha-trip-07.f20e4d55.png";